var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{ref:"googleLoginButton",staticClass:"google-login__button list-social__item",attrs:{"id":"glogin"}})
}
var staticRenderFns = []

export { render, staticRenderFns }